import { MainContent } from "components/Layout/components/Content";
import { Header, HeaderProps } from "components/Layout/components/Header/Header";
import { MasterLayout } from "components/Layout/components/MasterLayout";

/**
 * Emergency app selector page.
 * Currently selected app is persisted on client. In the unlikely case that the app will
 * be crashing and taking the React with itself (e.g. the app is unreachable),
 * the user might want to manually switch to another app - that's the purpose of this page.
 */
export const AppReset = ({ appTitle, username, userProfile }: HeaderProps) => {
    return (
        <MasterLayout>
            <Header appTitle={appTitle} username={username} userProfile={userProfile} />
            <MainContent id="pageContent">
                <h1>Manual app selector</h1>
                Pick application from top-right context menu.
            </MainContent>
        </MasterLayout>
    );
};
